import type { SVGAttributes } from 'react';
import { LoaderCircle } from 'lucide-react';

import { cn } from '../../lib/utils';

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

const sizeClasses: Record<SpinnerSize, string> = {
    xs: 'size-4',
    sm: 'size-5',
    md: 'size-6',
    lg: 'size-8',
};

export function Spinner({
    size = 'md',
    className,
    label = 'Loading',
}: {
    size?: SpinnerSize;
    className?: string;
    label?: string | null;
}) {
    const accessibilityProps: SVGAttributes<SVGSVGElement> = label
        ? { role: 'status', 'aria-label': label }
        : { 'aria-hidden': true };

    return (
        <LoaderCircle
            strokeWidth={2}
            className={cn(
                'animate-spin shrink-0 text-muted-foreground',
                sizeClasses[size],
                className,
            )}
            {...accessibilityProps}
        />
    );
}
